import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './SecondaryNavDesktop.module.less';

const SecondaryNavDesktopMenuContent = ({ links }) => {
  return (
    <ul className={styles.menuContent}>
      {links.map(link => (
        <li key={`secondary_${link.text}`} className={styles.menuContentItem}>
          <a className={styles.menuContentItemLink} href={link.url}>
            {link.text}
          </a>
        </li>
      ))}
    </ul>
  );
};

SecondaryNavDesktopMenuContent.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

SecondaryNavDesktopMenuContent.defaultProps = {
  links: [],
};

export default SecondaryNavDesktopMenuContent;
